import { ReturnSummaryStorageData } from '../models/returns';
import { RETURN_SUMMARY_SESSION_STORAGE_KEY } from '../constants/general';
import { isCookieEnabled } from './cookie-helper';
import { getWindow } from './general';

export const getFromStorage = async (name: string) => {
  const readOrderDetailsFromClipboard = isCookieEnabled('useClipboard');

  // local return flow experience
  if (readOrderDetailsFromClipboard) {
    try {
      const clipboardText = await navigator.clipboard.readText();
      const parsedText = JSON.parse(clipboardText);
      return JSON.stringify(parsedText);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to parse clipboard:', error);
      return '';
    }
  }
  // normal flow
  return sessionStorage.getItem(name);
};

/**
 * Sets the value in the session storage with the specified key.
 * @param key - The key to set in the session storage.
 * @param value - The value to be stored in the session storage.
 */
export const setSessionStorage = (key: string, value: object) => {
  const objectJsonString = JSON.stringify(value);
  getWindow()?.sessionStorage.setItem(key, objectJsonString);
};

export const disableAbandonmentSurvey = () => {
  window.sessionStorage?.setItem('displayReturnAbandonSurvey', 'false');
  window.sessionStorage?.setItem('displayLORPAbandonSurvey', 'false');
};
export const enableReturnAbandonmentSurvey = () => {
  window.sessionStorage?.setItem('displayReturnAbandonSurvey', 'true');
  window.sessionStorage?.setItem('displayLORPAbandonSurvey', 'false');
};
export const enableLORPAbandonmentSurvey = () => {
  window.sessionStorage?.setItem('displayReturnAbandonSurvey', 'false');
  window.sessionStorage?.setItem('displayLORPAbandonSurvey', 'true');
};

/**
 * Retrieves the return summary fields from the session storage.
 * If any of the required fields are missing, it redirects to the purchase history page.
 * @returns An object containing the orderId, emailId, returnItems, and returnTrackingNumbers.
 *          Returns undefined and redirects if any of the required fields are missing.
 */
export const getReturnSummaryFieldsFromStorage = async () => {
  const returnSummaryStorageData = sessionStorage.getItem(
    RETURN_SUMMARY_SESSION_STORAGE_KEY,
  );
  const parsedReturnSummaryObject = JSON.parse(
    returnSummaryStorageData || '{}',
  ) as ReturnSummaryStorageData;
  const {
    emailId,
    orderId,
    refundValues,
    hasDuplicateReturns = false,
    selectedPickupDate,
    summaryShipments,
  } = parsedReturnSummaryObject;

  // NOTE: for cash n carry, if they ever get allowed, we need to allow for no emailId.
  if (!orderId || !emailId) {
    // Redirect to purchase history if any of the required fields are missing
    window.location.replace(`/myaccount/purchase-history`);
    return undefined;
  }

  return {
    orderId,
    emailId,
    summaryShipments,
    refundValues,
    hasDuplicateReturns,
    selectedPickupDate,
  };
};
